export const SERVER_URL = "https://do-calculate.com/api";
export const CopyRightDate = "2025";
export const AgeGregorian_EndPoint = "calculate-age-gregorian";
export const AgeHijri_EndPoint = "calculate-age-hijri";
export const DateGregorianDifferences_EndPoint =
  "calculate-date-gregorian-differences";
export const DateHijriDifferences_EndPoint = "calculate-date-hijri-differences";
export const BMI_EndPoint = "calculate-bmi";
export const BMI_Child_EndPoint = "calculate-child-bmi";
export const Calories_EndPoint = "calculate-calories";
export const BMR_EndPoint = "calculate-bmr";
export const IdealWeight_EndPoint = "calculate-ideal-weight";
export const BodyFat_EndPoint = "calculate-body-fat";
export const FoodEnergy_EndPoint = "calculate-food-energy";
export const Money_Zakat_EndPoint = "calculate-money-zakat";
export const Gold_Zakat_EndPoint = "calculate-gold-zakat";
export const Gold_Karat_EndPoint = "calculate-gold-karat";
export const Silver_Zakat_EndPoint = "calculate-silver-zakat";
export const Fruits_Zakat_EndPoint = "calculate-fruits-zakat";
export const Trade_Zakat_EndPoint = "calculate-trade-zakat";
export const Animals_Zakat_EndPoint = "calculate-animals-zakat";
export const Period_EndPoint = "calculate-period";
export const Conception_EndPoint = "calculate-conception";
export const Ovulation_EndPoint = "calculate-ovulation";
export const DueDate_EndPoint = "calculate-due-date";
export const PregnancyConception_EndPoint = "calculate-pregnancy-conception";
export const WeightGainPregnancyCalculate_EndPoint =
  "calculate-pregnancy-weight-gain";
export const PregnancyCalculate_EndPoint = "calculate-pregnancy";
export const CalculatorsType = {
  humanCalculators: 1,
  healthCalculators: 200,
  womenCalculators: 300,
  islamicCalculators: 400,
  mathCalculators: 500,
  studyCalculators: 600,
  physicsCalculators: 700,
  otherCalculators: 800,
  TimeArticles_Ar: 900,
  TimeArticles_En: 1000,
};

export const otherCalculators_Fr = [
  {
    name: "Générateur de mot de passe",
    link: "/calculator/fr/random-password-generator/",
    description:
      "Générateur de mot de passe, mots de passe forts, protection de compte, sécurité des données, sécurité Internet, générateur de mot de passe aléatoire, lettres, chiffres et symboles, sécurité des comptes personnels, création d'un mot de passe fort.",
    showMain: true,
  },
  {
    name: "Générateur de nom musulman",
    link: "/calculator/fr/random-name-generator/",
    description:
      "Utilisez le générateur de noms pour découvrir une large variété de noms uniques et beaux. Que vous cherchiez des noms arabes, occidentaux, islamiques, orientaux, luxueux ou rares, ce générateur offre diverses options pour trouver le nom parfait pour votre nouveau-né !",
    showMain: true,
  },
  {
    name: "Générateur de nombre aléatoire",
    link: "/calculator/fr/random-number-generator/",
    description:
      "Utilisez le générateur de nombres pour découvrir une large variété de nombres uniques et beaux. Que vous cherchiez des nombres arabes, occidentaux, islamiques, orientaux, luxueux ou rares, ce générateur offre diverses options pour trouver le nombre parfait pour votre nouveau-né !",
    showMain: true,
  },
  {
    name: "Compteur électronique de Dhikr (compteur de pointages)",
    link: "/calculator/fr/tally-counter/",
    description:
      "Le compteur électronique de Dhikr (compteur de pointages) vous aide à suivre votre nombre de Dhikr facilement et commodément. Vous pouvez l'utiliser pour compter votre Dhikr pendant les prières ou à tout autre moment où vous souhaitez pratiquer le souvenir d'Allah. Le compteur est conçu pour être convivial et fiable, rendant votre pratique spirituelle plus focalisée et organisée.",
    showMain: true,
  },
  { name: "Test de vitesse Internet", link: "/calculator/fr/internet-speed/", description: "Testez la vitesse de votre connexion Internet.", showMain: true },
  { name: "Décorateur de texte", link: "/calculator/fr/text-decorator/", description: "Décorez et stylisez votre texte.", showMain: true },
  { name: "Temps pour apprendre l'anglais", link: "/calculator/fr/english-learning-time-calculator/", description: "Calculez le temps nécessaire pour apprendre l'anglais.", showMain: true },
  { name: "Temps pour apprendre l'allemand", link: "/calculator/fr/german-learning-time-calculator/", description: "Calculez le temps nécessaire pour apprendre l'allemand.", showMain: true },
  { name: "Temps pour apprendre le français", link: "/calculator/fr/french-learning-time-calculator/", description: "Calculez le temps nécessaire pour apprendre le français.", showMain: true },
  { name: "Calculatrice de durée de batterie", link: "/calculator/fr/battery-life-calculator/", description: "Calculez la durée de vie de votre batterie.", showMain: true },
  { name: "Calculatrice de différence de taille", link: "/calculator/fr/height-difference-calculator/", description: "Calculez la différence de taille entre deux personnes.", showMain: true },
  { name: "Compteur de mots", link: "/calculator/fr/word-counter/", description: "Comptez les mots dans un texte.", showMain: true },
  { name: "Calculatrice d'heures d'absence universitaire", link: "/calculator/fr/absence-calculator/", description: "Calculez vos heures d'absence à l'université.", showMain: true },
];

export const humanCalculators_Fr = [
  {
    name: "Calculatrice d'âge grégorien",
    link: "/calculator/fr/agegregorian/",
    description:
      "Ce calculateur calcule l'âge en années, mois et jours en utilisant le calendrier grégorien et hégirien.",
    showMain: true,
  },
  {
    name: "Calculatrice d'âge hégirien",
    link: "/calculator/fr/agehijri/",
    description:
      "Calculez votre âge selon le calendrier hégirien (islamique) en entrant votre date de naissance au format hégirien ou grégorien. Utilisez la calculatrice d'âge hégirien pour convertir les dates en âges précis basés sur le calendrier islamique.",
    showMain: true,
  },
  {
    name: "Calculatrice de différence d'âge",
    link: "/calculator/fr/gregoriandifferences/",
    description:
      "Ce calculateur calcule la différence d'âge entre deux personnes en utilisant le calendrier grégorien.",
    showMain: true,
  },
  {
    name: "Calculatrice de différence de date grégorienne",
    link: "/calculator/fr/dategregoriandifferences/",
    description:
      "Ce calculateur est utilisé pour calculer la différence entre deux dates spécifiques en utilisant le calendrier grégorien.",
    showMain: true,
  },
  {
    name: "Calculatrice de différence de date hégirien",
    link: "/calculator/fr/datehijridifferences/",
    description:
      "Ce calculateur calcule la différence entre deux dates spécifiques en utilisant le calendrier hégirien.",
    showMain: true,
  },
  {
    name: "Calculatrice d'anniversaire",
    link: "/calculator/fr/birthday/",
    description:
      "Utilisez cette calculatrice pour découvrir le temps détaillé restant jusqu'à votre anniversaire dans le calendrier grégorien. Entrez votre date d'anniversaire pour obtenir la différence entre l'heure actuelle et votre anniversaire en mois et jours.",
    showMain: true,
  },
  {
    name: "Convertisseur grégorien en hégirien",
    link: "/calculator/fr/gregorian_to_hijri/",
    description:
      "Convertissez la date du calendrier grégorien au calendrier hégirien en entrant la date grégorienne et en trouvant son équivalent hégirien en utilisant le convertisseur de date électronique.",
    showMain: true,
  },
  {
    name: "Convertisseur hégirien en grégorien",
    link: "/calculator/fr/hijri_to_gregorian/",
    description:
      "Convertissez la date du calendrier hégirien au calendrier grégorien en entrant la date hégirien et en trouvant son équivalent grégorien en utilisant le convertisseur de date électronique.",
  },
  {
    name: "Calculatrice de temps en ligne",
    link: "/calculator/fr/time-calculator/",
    description:
      "La calculatrice gratuite de temps et de durée vous aide à ajouter ou à soustraire les valeurs de temps en termes de jours, heures, minutes ou secondes facilement. Vous pouvez également apprendre divers concepts de temps.",
  },
  { name: "Calculatrice de jours", link: "/calculator/fr/days-calculator/", description: "Calculez le nombre de jours entre deux dates.", showMain: true },
  { name: "Compte à rebours d'anniversaire", link: "/calculator/fr/birthday/", description: "Calculez combien de jours jusqu'à votre prochain anniversaire.", showMain: true },
  { name: "Date du jour (grégorien et hégirien)", link: "/calculator/fr/current-date-display/", description: "Affichez la date du jour en calendrier grégorien et hégirien.", showMain: true },
  { name: "Calculatrice de durée de vie", link: "/calculator/fr/death-calculator/", description: "Estimez la durée de vie.", showMain: true },
{ name: "Années de naissance (1960–2026)", link: "/calculator/fr/gregorian/gregorian-year-list/", description: "Consultez les années de naissance de 1960 à 2026 et calculez votre âge avec précision selon votre année de naissance."},
];

export const healthCalculators_Fr = [
  {
    name: "Calcul de l'indice de masse corporelle (IMC) - Adultes",
    link: "/calculator/fr/bmiadults/",
    description:
      "Ce calculateur calcule l'indice de masse corporelle (IMC) pour les adultes.",
    showMain: true,
  },
  {
    name: "Calcul de l'indice de masse corporelle (IMC) - Enfants",
    link: "/calculator/fr/bmichildren/",
    description:
      "Ce calculateur est utilisé pour calculer l'indice de masse corporelle (IMC) pour les enfants.",
    showMain: true,
  },
  {
    name: "Calculatrice de calories",
    link: "/calculator/fr/calories/",
    description:
      "Ce calculateur calcule les besoins caloriques quotidiens pour maintenir, augmenter ou perdre du poids.",
    showMain: true,
  },
  {
    name: "Calcul du taux métabolique de base (BMR)",
    link: "/calculator/fr/bmr/",
    description:
      "Ce calculateur calcule le taux métabolique de base (BMR), qui représente les calories dont votre corps a besoin au repos.",
    showMain: true,
  },
  {
    name: "Calcul du poids idéal pour la taille",
    link: "/calculator/fr/idealweight/",
    description:
      "Ce calculateur aide à calculer le poids idéal qui correspond à votre taille.",
    showMain: true,
  },
  {
    name: "Calcul du pourcentage de graisse corporelle",
    link: "/calculator/fr/bodyfat/",
    description:
      "Ce calculateur est utilisé pour calculer le pourcentage de graisse corporelle en fonction de certaines mesures.",
    showMain: true,
  },
  {
    name: "Calcul des glucides dans le corps",
    link: "/calculator/fr/carbohydrate/",
    description:
      "Ce calculateur calcule la quantité appropriée de glucides à consommer quotidiennement.",
    showMain: true,
  },
  {
    name: "Calculatrice de conversion d'unité d'énergie alimentaire",
    link: "/calculator/fr/foodenergy/",
    description:
      "Ce calculateur aide à convertir entre différentes unités d'énergie alimentaire telles que les calories, les joules et les kilojoules.",
  },
  {
    name: "Calculatrice de protéines",
    link: "/calculator/fr/protein/",
    description:
      "Utilisez la calculatrice de protéines pour estimer le montant spécifié de protéines à consommer quotidiennement (grammes/jour) pour la perte de poids et le gain musculaire.",
  },
  {
    name: "Calculatrice de sommeil sain",
    link: "/calculator/fr/sleep/",
    description:
      "Utilisez cette calculatrice pour calculer le bon moment pour vous coucher ou vous réveiller afin de vous réveiller rafraîchi entre les cycles de sommeil.",
  },
  { name: "Calculatrice de type corporel", link: "/calculator/fr/body-type-calculator/", description: "Déterminez votre morphologie corporelle.", showMain: true },
  { name: "Calculatrice d'apport en eau quotidien", link: "/calculator/fr/water-intake-calculator/", description: "Calculez votre apport en eau quotidien recommandé.", showMain: true },
  { name: "Calculatrice des valeurs nutritionnelles", link: "/calculator/fr/food-nutrients-calculator/", description: "Consultez les valeurs nutritionnelles des aliments.", showMain: true },
  { name: "Calculatrice de l'indice adipeux corporel (IAC)", link: "/calculator/fr/bai-calculator/", description: "Calculez l'indice adipeux corporel (BAI).", showMain: true },
  { name: "Calculatrice de forme de visage", link: "/calculator/fr/face-shape-calculator/", description: "Déterminez la forme de votre visage.", showMain: true },
  { name: "Calculatrice de glycémie", link: "/calculator/fr/blood-sugar-calculator/", description: "Surveillez votre glycémie.", showMain: true },
  { name: "Calculatrice du risque de diabète", link: "/calculator/fr/diabetes-risk-calculator/", description: "Évaluez votre risque de diabète.", showMain: true },
  { name: "Calculatrice de glucose moyen estimé", link: "/calculator/fr/glucose-calculator/", description: "Calculez votre taux de glucose moyen estimé.", showMain: true },
  { name: "Calculatrice de dosage médicamenteux", link: "/calculator/fr/drug-dosage-calculator/", description: "Calculez les doses de médicaments en mg/kg.", showMain: true },
  { name: "Calculatrice de dosage médical", link: "/calculator/fr/medicine-dosage-calculator/", description: "Calculez les dosages de médicaments.", showMain: true },
  { name: "Calculatrice de dosage paracétamol enfants", link: "/calculator/fr/paracetamol-children-dosage/", description: "Dose de paracétamol pour enfants selon le poids.", showMain: true },
  { name: "Calculatrice du débit de filtration glomérulaire (DFG)", link: "/calculator/fr/gfr-calculator/", description: "Calculez la fonction rénale via le DFG.", showMain: true },
  { name: "Test de vision", link: "/calculator/fr/eye-test/", description: "Testez votre acuité visuelle.", showMain: true },
  { name: "Calculatrice des zones de fréquence cardiaque", link: "/calculator/fr/heart-rate-calculator/", description: "Calculez vos zones de fréquence cardiaque.", showMain: true },
  { name: "Calculatrice d'addiction", link: "/calculator/fr/addiction-calculator/", description: "Évaluez votre risque d'addiction.", showMain: true },
  { name: "Calculatrice de récupération après le tabac", link: "/calculator/fr/smoking-recovery-calculator/", description: "Suivez votre récupération après l'arrêt du tabac.", showMain: true },
  { name: "Calculatrice du ratio cholestérol", link: "/calculator/fr/cholesterol-ratio-calculator/", description: "Calculez votre ratio cholestérol HDL/LDL.", showMain: true },
  { name: "Calculatrice de calories depuis les pas", link: "/calculator/fr/steps-to-calories-calculator/", description: "Convertissez vos pas en calories brûlées.", showMain: true },
  { name: "Calculatrice de calories de marche", link: "/calculator/fr/walking-calorie-calculator/", description: "Calculez les calories brûlées en marchant.", showMain: true },
  { name: "Calculatrice de caféine quotidienne", link: "/calculator/fr/coffee-caffeine-calculator/", description: "Calculez votre consommation de caféine.", showMain: true },
  { name: "Calculatrice de fréquence cardiaque", link: "/calculator/fr/heartbeat-calculator/", description: "Calculez votre fréquence cardiaque.", showMain: true },
  { name: "Calculatrice de taux métabolique de repos (RMR)", link: "/calculator/fr/rmr-calculator/", description: "Calculez votre taux métabolique de repos.", showMain: true },
  { name: "Calculatrice de l'indice de satiété", link: "/calculator/fr/satiety-index-calculator/", description: "Évaluez le pouvoir rassasiant des aliments.", showMain: true },
  { name: "Calculatrice du volume courant", link: "/calculator/fr/tidal-volume-calculator/", description: "Calculez le volume courant respiratoire.", showMain: true },
  { name: "Calculatrice de perte de poids", link: "/calculator/fr/weight-loss-calculator/", description: "Calculez votre objectif de perte de poids.", showMain: true },
];

export const financialCalculators_Fr = [
  {
    name: "Calculatrice du ratio Prix/Bénéfices (P/E)",
    link: "/calculator/fr/pe-ratio/",
    description:
      "La calculatrice du ratio Prix/Bénéfices (P/E) calcule le ratio P/E pour les entreprises en fonction de la valeur marchande de l'action et du bénéfice par action.",
    showMain: true,
  },
  {
    name: "Calculatrice de l'impact de l'inflation",
    link: "/calculator/fr/inflation/",
    description:
      "La calculatrice de l'impact de l'inflation calcule le montant d'argent qui perd de sa valeur en raison de l'inflation entre deux périodes différentes.",
    showMain: true,
  },
  {
    name: "Calculatrice Google AdSense",
    link: "/calculator/fr/google-adsense/",
    description:
      "Calculatrice gratuite des revenus Google AdSense - découvrez combien d'argent votre site Web peut générer. Cet outil utilise des données de Google.",
    showMain: true,
  },
  {
    name: "Calculatrice TVA",
    link: "/calculator/fr/vat/",
    description:
      "Calculez les taux de TVA avec notre calculatrice TVA en ligne gratuite. Déterminez facilement les montants de TVA pour vos transactions.",
    showMain: true,
  },
  { name: "Calculatrice des ventes nettes", link: "/calculator/fr/net-sales-calculator/", description: "Calculez vos ventes nettes.", showMain: true },
  { name: "Calculatrice de coût de carburant", link: "/calculator/fr/fuel-cost-calculator/", description: "Estimez le coût de votre carburant.", showMain: true },
  { name: "Calculatrice de remise", link: "/calculator/fr/discount-calculator/", description: "Calculez les remises et réductions.", showMain: true },
  { name: "Calculatrice de salaire horaire", link: "/calculator/fr/hourly-salary-calculator/", description: "Calculez votre salaire horaire depuis le salaire mensuel.", showMain: true },
  { name: "Calculatrice de salaire journalier", link: "/calculator/fr/daily-salary-calculator/", description: "Calculez votre salaire quotidien depuis le salaire mensuel.", showMain: true },
  { name: "Calculatrice de marge bénéficiaire", link: "/calculator/fr/profit-margin-calculator/", description: "Calculez votre marge bénéficiaire.", showMain: true },
  { name: "Calculatrice d'augmentation de salaire", link: "/calculator/fr/salary-bonus-calculator/", description: "Calculez votre augmentation de salaire.", showMain: true },
  { name: "Calculatrice de frais PayPal", link: "/calculator/fr/paypal-fee/", description: "Calculez les frais PayPal sur vos transactions.", showMain: true },
  { name: "Calculatrice de commission", link: "/calculator/fr/commission-calculator/", description: "Calculez votre commission commerciale.", showMain: true },
  { name: "Calculatrice de bénéfice brut", link: "/calculator/fr/gross-profit-calculator/", description: "Calculez le bénéfice brut.", showMain: true },
  { name: "Calculatrice de retour sur investissement (ROI)", link: "/calculator/fr/roi-calculator/", description: "Calculez votre retour sur investissement.", showMain: true },
  { name: "Calculatrice du seuil de rentabilité", link: "/calculator/fr/break-even-calculator/", description: "Calculez votre seuil de rentabilité.", showMain: true },
  { name: "Calculatrice CAGR", link: "/calculator/fr/cagr-calculator/", description: "Calculez le taux de croissance annuel composé.", showMain: true },
  { name: "Calculatrice de prise de bénéfice", link: "/calculator/fr/take-profit-calculator/", description: "Calculez vos objectifs de prise de bénéfice.", showMain: true },
];

export const womenCalculators_Fr = [
  {
    name: "Calculatrice du cycle menstruel",
    link: "/calculator/fr/period/",
    description:
      "Ce calculateur aide à suivre le cycle menstruel et à déterminer les périodes fertiles.",
    showMain: true,
  },
  {
    name: "Calculatrice de grossesse",
    link: "/calculator/fr/pregnancy/",
    description:
      "Ce calculateur est utilisé pour calculer la date prévue d'accouchement et estimer la semaine actuelle de grossesse.",
    showMain: true,
  },
  {
    name: "Calculatrice de la date de conception pendant la grossesse",
    link: "/calculator/fr/pregnancy-conception/",
    description:
      "Ce calculateur calcule la date de conception pendant la grossesse.",
    showMain: true,
  },
  {
    name: "Calculatrice de la date prévue d'accouchement",
    link: "/calculator/fr/pregnancy-due-date/",
    description:
      "Ce calculateur est utilisé pour estimer la date prévue d'accouchement en fonction de la date du début de la grossesse.",
    showMain: true,
  },
  {
    name: "Calculatrice de la date d'ovulation",
    link: "/calculator/fr/ovulation/",
    description:
      "Ce calculateur aide à estimer la date d'ovulation et le meilleur moment pour la conception.",
    showMain: true,
  },
  {
    name: "Calculatrice de la date de conception",
    link: "/calculator/fr/conception/",
    description:
      "Ce calculateur est utilisé pour calculer la date de conception en fonction de votre cycle menstruel et de la durée du cycle.",
    showMain: true,
  },
  { name: "Calculatrice de taille de soutien-gorge", link: "/calculator/fr/bra-size-calculator/", description: "Calculez votre taille de soutien-gorge.", showMain: true },
];

export const islamicCalculators_Fr = [
  {
    name: "Calculatrice de Zakat sur la richesse",
    link: "/calculator/fr/money-zakat/",
    description:
      "Ce calculateur est utilisé pour calculer la Zakat sur la richesse et les aumônes conformément aux règles islamiques.",
    showMain: true,
  },
  {
    name: "Calculatrice de Zakat sur l'or",
    link: "/calculator/fr/gold-zakat/",
    description:
      "Ce calculateur calcule la Zakat sur l'or et les bijoux selon les conditions de la Charia.",
    showMain: true,
  },
  {
    name: "Calculatrice de Zakat sur l'argent",
    link: "/calculator/fr/silver-zakat/",
    description:
      "Ce calculateur est utilisé pour calculer la Zakat sur l'argent et les métaux précieux selon les décisions religieuses islamiques.",
    showMain: true,
  },
  {
    name: "Calculatrice de Zakat sur les fruits",
    link: "/calculator/fr/fruits-zakat/",
    description:
      "Ce calculateur calcule la Zakat sur les fruits et les produits agricoles selon les règles religieuses.",
    showMain: true,
  },
  {
    name: "Calculatrice de Zakat sur le commerce",
    link: "/calculator/fr/trade-zakat/",
    description:
      "Ce calculateur est utilisé pour calculer la Zakat sur les actifs commerciaux et le capital d'investissement.",
    showMain: true,
  },
  {
    name: "Calculatrice de Zakat sur les animaux",
    link: "/calculator/fr/animals-zakat/",
    description:
      "Ce calculateur calcule la Zakat sur les animaux et le bétail selon les règles de la Charia.",
    showMain: true,
  },
  {
    name: "Calculatrice de conversion du carat d'or",
    link: "/calculator/fr/gold-karat/",
    description:
      "Ce calculateur est utilisé pour convertir les unités de carat d'or en d'autres unités telles que les grammes et les onces.",
    showMain: true,
  },
];

export const comingSoon_Fr = [{ name: "À venir", link: "#" }];

export const mathCalculators_Fr = [
  {
    name: "Calculatrice de pourcentage",
    link: "/calculator/fr/percentage/",
    description:
      "Ce calculateur est utilisé pour calculer les pourcentages et les augmentations ou diminutions de pourcentage.",
    showMain: true,
  },
  {
    name: "Calculatrice de volume",
    link: "/calculator/fr/volumes/",
    description:
      "Cette calculatrice gratuite calcule les volumes de formes courantes incluant la sphère, le cône, le cube, le cylindre, la capsule, la calotte, le cône tronqué, l'ellipsoïde, la pyramide, le tube et bien d'autres.",
    showMain: true,
  },
  {
    name: "Calculatrice de racine",
    link: "/calculator/fr/roots/",
    description:
      "Cette calculatrice gratuite calcule les racines des nombres, y compris les racines courantes comme la racine carrée ou la racine cubique, et calcule la racine pour n'importe quel nombre donné.",
    showMain: true,
  },
  {
    name: "Calculatrice d'aire",
    link: "/calculator/fr/areas/",
    description:
      "Ce calculateur calcule l'aire de diverses formes géométriques courantes, y compris le rectangle, le triangle, le parallélogramme, le cercle, le secteur et l'ellipse.",
    showMain: true,
  },
  {
    name: "Calculatrice de rang médian",
    link: "/calculator/fr/median/",
    description:
      "La calculatrice de valeur médiane calcule le rang médian et explique comment le calculer.",
    showMain: true,
  },
  {
    name: "Calculatrice de circonférence du cylindre",
    link: "/calculator/fr/cylinder-circumference/",
    description:
      "La calculatrice de circonférence du cylindre calcule la circonférence d'un cylindre en fonction de son diamètre et de sa hauteur.",
    showMain: true,
  },
  {
    name: "Calculatrice d'aire du réservoir",
    link: "/calculator/fr/tank-area/",
    description:
      "La calculatrice d'aire du réservoir calcule l'aire d'un réservoir en fonction de ses dimensions et des rectangles qui le composent.",
    showMain: true,
  },
  {
    name: "Calculatrice de longueur de côté d'un carré",
    link: "/calculator/fr/square-side-length/",
    description:
      "La calculatrice de longueur de côté d'un carré calcule la longueur du côté d'un carré en fonction de l'aire ou du périmètre d'entrée.",
  },
  {
    name: "Calculatrice du pourcentage d'absence",
    link: "/calculator/fr/absence-percentage/",
    description:
      "La calculatrice du pourcentage d'absence calcule le pourcentage d'absence en fonction de la présence totale et du nombre d'absences.",
  },
  {
    name: "Calculatrice du pourcentage de présence",
    link: "/calculator/fr/attendance-percentage/",
    description:
      "La calculatrice du pourcentage de présence calcule le pourcentage de présence en fonction de la présence totale et du nombre d'absences.",
  },
  {
    name: "Calculatrice de densité de population",
    link: "/calculator/fr/population-density/",
    description:
      "La calculatrice de densité de population calcule la densité de population en fonction du nombre de population et de la surface.",
  },
  {
    name: "Calculatrice du taux de réussite et d'échec",
    link: "/calculator/fr/success-failure-rate/",
    description:
      "La calculatrice du taux de réussite et d'échec calcule les taux de réussite et d'échec en fonction du nombre de réussites et des tentatives totales.",
  },
  {
    name: "Calculatrice d'un cinquième",
    link: "/calculator/fr/one-fifth/",
    description:
      "La calculatrice d'un cinquième calcule un cinquième d'un montant total en fonction du montant d'entrée.",
  },
  {
    name: "Calculatrice du rayon du cercle",
    link: "/calculator/fr/circle-radius/",
    description:
      "La calculatrice du rayon du cercle calcule le rayon d'un cercle en utilisant des informations telles que le diamètre, la circonférence ou l'aire du cercle.",
    showMain: true,
  },

  {
    name: "Calculatrice de 5% d'un montant",
    link: "/calculator/fr/5percent/",
    description:
      "Apprenez à calculer 5% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 5% d'un montant spécifique.",
  },
  {
    name: "Calculatrice de 10% d'un montant",
    link: "/calculator/fr/10percent/",
    description:
      "Apprenez à calculer 10% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 10% d'un montant spécifique.",
  },
  {
    name: "Calculatrice de 15% d'un montant",
    link: "/calculator/fr/15percent/",
    description:
      "Apprenez à calculer 15% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 15% d'un montant spécifique.",
  },
  {
    name: "Calculatrice de 20% d'un montant",
    link: "/calculator/fr/20percent/",
    description:
      "Apprenez à calculer 20% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 20% d'un montant spécifique.",
  },
  {
    name: "Calculatrice de 25% d'un montant",
    link: "/calculator/fr/25percent/",
    description:
      "Apprenez à calculer 25% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 25% d'un montant spécifique.",
  },
  {
    name: "Calculatrice de 30% d'un montant",
    link: "/calculator/fr/30percent/",
    description:
      "Apprenez à calculer 30% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 30% d'un montant spécifique.",
  },
  {
    name: "Calculatrice de 35% d'un montant",
    link: "/calculator/fr/35percent/",
    description:
      "Apprenez à calculer 35% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 35% d'un montant spécifique.",
  },
  {
    name: "Calculatrice de 40% d'un montant",
    link: "/calculator/fr/40percent/",
    description:
      "Apprenez à calculer 40% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 40% d'un montant spécifique.",
  },
  {
    name: "Calculatrice de 75% d'un montant",
    link: "/calculator/fr/75percent/",
    description:
      "Apprenez à calculer 75% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 75% d'un montant spécifique.",
  },
  {
    name: "Calculatrice d'un cinquième",
    link: "/calculator/fr/one-fifth/",
    description:
      "La calculatrice d'un cinquième calcule un cinquième d'un montant total en fonction du montant d'entrée.",
  },
  { name: "Calculatrice de 45% d'un montant", link: "/calculator/fr/45percent/", description: "Calculez 45% d'un montant.", showMain: true },
  { name: "Calculatrice du triangle", link: "/calculator/fr/triangle-calculator/", description: "Calculez les propriétés d'un triangle.", showMain: true },
  { name: "Calculatrice moyenne, médiane, mode et étendue", link: "/calculator/fr/mean-median-mode-calculator/", description: "Calculez la moyenne, médiane, mode et étendue d'une série.", showMain: true },
  { name: "Calculatrice du cercle", link: "/calculator/fr/circle-calculator/", description: "Calculez la circonférence et l'aire d'un cercle.", showMain: true },
  { name: "Calculatrice d'arrondi", link: "/calculator/fr/rounding-calculator/", description: "Arrondissez un nombre au multiple souhaité.", showMain: true },
  { name: "Calculatrice du carré d'un nombre", link: "/calculator/fr/squared-calculator/", description: "Calculez le carré d'un nombre.", showMain: true },
  { name: "Calculatrice du PPCM (Plus Petit Commun Multiple)", link: "/calculator/fr/lcm-calculator/", description: "Calculez le plus petit commun multiple.", showMain: true },
  { name: "Calculatrice du PGCD (Plus Grand Commun Diviseur)", link: "/calculator/fr/gcf-calculator/", description: "Calculez le plus grand commun diviseur.", showMain: true },
  { name: "Calculatrice de facteurs", link: "/calculator/fr/factor-calculator/", description: "Trouvez tous les facteurs d'un nombre.", showMain: true },
  { name: "Calculatrice de béton", link: "/calculator/fr/concrete-calculator/", description: "Calculez la quantité de béton nécessaire.", showMain: true },
  { name: "Calculatrice de taille d'échantillon", link: "/calculator/fr/sample-size-calculator/", description: "Calculez la taille d'échantillon pour une étude statistique.", showMain: true },
  { name: "Calculatrice de hauteur du trapèze", link: "/calculator/fr/trapezoid-height-calculator/", description: "Calculez la hauteur d'un trapèze.", showMain: true },
  { name: "Calculatrice de matrices", link: "/calculator/fr/matrix-operations/", description: "Effectuez des opérations sur les matrices.", showMain: true },
  { name: "Calculatrice de fractions", link: "/calculator/fr/fractions-calculator/", description: "Calculez des opérations sur les fractions.", showMain: true },
  { name: "Calculatrice de simplification de fractions", link: "/calculator/fr/simplifying-fractions-calculator/", description: "Simplifiez des fractions.", showMain: true },
  { name: "Calculatrice de litres", link: "/calculator/fr/liter-converter/", description: "Convertissez des volumes en litres.", showMain: true },
  { name: "Calculatrice des deux tiers", link: "/calculator/fr/two-thirds-calculator/", description: "Calculez deux tiers d'un nombre.", showMain: true },
  { name: "Calculatrice du tiers", link: "/calculator/fr/one-third-calculator/", description: "Calculez un tiers d'un nombre.", showMain: true },
  { name: "Calculatrice du quart", link: "/calculator/fr/quarter-calculator/", description: "Calculez un quart d'un nombre.", showMain: true },
  { name: "Calculatrice des angles du triangle", link: "/calculator/fr/triangle-angles-calculator/", description: "Calculez les angles d'un triangle.", showMain: true },
  { name: "Calculatrice du diamètre du carré", link: "/calculator/fr/square-diameter-calculator/", description: "Calculez la diagonale d'un carré.", showMain: true },
  { name: "Calculatrice de l'hypoténuse du triangle", link: "/calculator/fr/triangle-hypotenuse-calculator/", description: "Calculez l'hypoténuse d'un triangle rectangle.", showMain: true },
  { name: "Division longue", link: "/calculator/fr/long-division-calculator/", description: "Effectuez une division longue étape par étape.", showMain: true },
  { name: "Calculatrice trigonométrique", link: "/calculator/fr/trigonometry-calculator/", description: "Calculez les fonctions trigonométriques sin, cos, tan.", showMain: true },
];

export const studyCalculators_Fr = [
  {
    name: "Convertisseur de tableau GPA",
    link: "/calculator/fr/gpatableconverter/",
    description:
      "Ce calculateur aide à convertir le GPA cumulatif des étudiants à différentes échelles, telles que GPA, système de pourcentage, etc.",
    showMain: true,
  },
  {
    name: "Calculatrice de note universitaire internationale",
    link: "/calculator/fr/gpagrade/",
    description:
      "Ce calculateur calcule la note universitaire en fonction du système de classement international.",
    showMain: true,
  },
  {
    name: "Calculatrice GPA sur une échelle de 4,0",
    link: "/calculator/fr/gpa4/",
    description:
      "Utilisez cette calculatrice pour calculer le GPA cumulatif en fonction d'un système de classement de 4,0.",
    showMain: true,
  },
  {
    name: "Calculatrice GPA sur une échelle de 5,0",
    link: "/calculator/fr/gpa5/",
    description:
      "Ce calculateur calcule le GPA cumulatif en fonction d'un système de classement de 5,0.",
    showMain: true,
  },
  {
    name: "Convertisseur de note en pourcentage",
    link: "/calculator/fr/grade100/",
    description:
      "Ce calculateur convertit les notes du système de classement au système de pourcentage.",
    showMain: true,
  },
  {
    name: "Calculatrice de planification GPA",
    link: "/calculator/fr/gpaplanner/",
    description:
      "Utilisez cette calculatrice pour planifier votre GPA cumulatif futur en fonction des notes attendues.",
    showMain: true,
  },
  {
    name: "Conversion de note entre les échelles 100 et 4",
    link: "/calculator/fr/grade100to4/",
    description:
      "Ce calculateur aide à convertir les notes entre le système de pourcentage et l'échelle de classement de 4,0 et vice versa.",
    showMain: true,
  },
  {
    name: "Convertir GPA de 5 à 100 et vice versa",
    link: "/calculator/fr/grade100to5/",
    description:
      "Convertissez facilement votre GPA cumulatif entre les systèmes de 5 points et 100 points. Apprenez à convertir votre GPA de 5 à 100 et vice versa en utilisant cet outil simple.",
  },
  {
    name: "Convertisseur GPA : Échelle 4,0 à Échelle 5,0 et vice versa",
    link: "/calculator/fr/gpa4to5/",
    description:
      "Utilisez cette calculatrice pour convertir le GPA cumulatif entre les échelles de classement de 4,0 et 5,0.",
  },
  {
    name: "Calculatrice de note d'examen",
    link: "/calculator/fr/test-grade/",
    description:
      "Calculez facilement votre score d'examen et votre note à l'aide de la calculatrice de note avancée. Obtenez le pourcentage et la note alphabétique en fonction du nombre de points et des réponses incorrectes.",
  },
  {
    name: "Conversion au système de classement britannique",
    link: "/calculator/fr/gradetouk/",
    description:
      "Ce calculateur convertit le GPA cumulatif au système de classement britannique.",
  },
  {
    name: "Convertir GPA universitaire au système allemand",
    link: "/calculator/fr/gradetogerman/",
    description:
      "Convertissez facilement et précisément votre GPA universitaire au système allemand. Apprenez à convertir votre GPA de Bachelor et Master au système allemand en utilisant cet outil utile.",
  },
  {
    name: "Convertir GPA universitaire au système français",
    link: "/calculator/fr/gradetofrench/",
    description:
      "Découvrez comment convertir facilement et précisément votre GPA universitaire au système français. Apprenez les détails du système français de classement universitaire.",
  },
  {
    name: "Convertir GPA universitaire au système canadien",
    link: "/calculator/fr/gradetocanada/",
    description:
      "Découvrez comment convertir facilement et précisément votre GPA universitaire au système canadien. Apprenez les détails du système canadien de classement universitaire.",
  },
  {
    name: "Convertir GPA universitaire au système de classement malais",
    link: "/calculator/fr/gradetomalaysia/",
    description:
      "Apprenez à convertir facilement et précisément votre GPA cumulatif au système de classement malais. Découvrez le système de classement des universités malaises.",
  },
  {
    name: "Convertir GPA cumulatif au système turc",
    link: "/calculator/fr/gradetoturkey/",
    description:
      "Découvrez comment convertir facilement et précisément votre GPA universitaire au système turc. Apprenez les détails du système turc de classement universitaire.",
  },
  {
    name: "Convertir GPA cumulatif au système australien",
    link: "/calculator/fr/gradetoaustralia/",
    description:
      "Découvrez comment convertir facilement et précisément votre GPA universitaire au système australien. Apprenez les détails du système australien de classement universitaire.",
  },
];

export const physicsCalculators_Fr = [
  {
    name: "Calculatrice d'heure d'arrivée",
    link: "/calculator/fr/arrivaltime/",
    description:
      "La calculatrice d'heure d'arrivée calcule le temps qu'il faut à une personne, un véhicule ou un objet en mouvement pour atteindre une destination en fonction de la vitesse et de la distance.",
    showMain: true,
  },
  {
    name: "Calculatrice de mètre cube",
    link: "/calculator/fr/cubicmeter/",
    description:
      "Cette calculatrice calcule le mètre cube - calculatrice électronique de mètre cube - apprenez à calculer le mètre cube.",
    showMain: true,
  },
  {
    name: "Calculatrice de puissance de lentille",
    link: "/calculator/fr/lenspower/",
    description:
      "La calculatrice électronique de puissance de lentille calcule précisément la puissance de la lentille oculaire (dioptrie) rapidement et précisément.",
    showMain: true,
  },
  {
    name: "Calculatrice de volume de gaz",
    link: "/calculator/fr/gasvolume/",
    description:
      "Cette calculatrice calcule facilement le volume de gaz et clarifie les étapes requises pour le calculer.",
    showMain: true,
  },
  {
    name: "Calculatrice de charge électrique",
    link: "/calculator/fr/electric-charge/",
    description:
      "La calculatrice de charge électrique calcule la valeur de la charge électrique en fonction de la force entre deux corps chargés.",
    showMain: true,
  },
  {
    name: "Calculatrice de vitesse",
    link: "/calculator/fr/velocity/",
    description:
      "La calculatrice de vitesse calcule la vitesse en fonction de la distance et du temps.",
    showMain: true,
  },
  {
    name: "Calculatrice d'accélération",
    link: "/calculator/fr/acceleration/",
    description:
      "La calculatrice d'accélération calcule l'accélération en fonction des changements de vitesse et du temps.",
    showMain: true,
  },
  {
    name: "Calculatrice d'énergie photonique",
    link: "/calculator/fr/photonenergy/",
    description:
      "La calculatrice d'énergie photonique calcule l'énergie du photon en fonction de la fréquence du photon et de la constante de Planck.",
  },
  {
    name: "Calculatrice de force de friction",
    link: "/calculator/fr/frictionforce/",
    description:
      "La calculatrice de force de friction calcule la force de friction en fonction de l'accélération et de la masse.",
  },
  {
    name: "Calculatrice de puissance du moteur",
    link: "/calculator/fr/horsepower/",
    description:
      "Utilisez la calculatrice de puissance du moteur pour estimer la puissance du moteur de votre véhicule. Entrez les détails clés et obtenez des résultats précis.",
  },
  { name: "Calculatrice d'énergie cinétique", link: "/calculator/fr/kinetic-energy-calculator/", description: "Calculez l'énergie cinétique d'un objet en mouvement.", showMain: true },
  { name: "Calculatrice d'énergie potentielle", link: "/calculator/fr/potential-energy-calculator/", description: "Calculez l'énergie potentielle d'un objet.", showMain: true },
  { name: "Calculatrice d'énergie électrique", link: "/calculator/fr/electrical-energy-calculator/", description: "Calculez l'énergie électrique consommée.", showMain: true },
  { name: "Calculatrice de la loi d'Ohm", link: "/calculator/fr/ohms-law/", description: "Calculez tension, courant et résistance avec la loi d'Ohm.", showMain: true },
  { name: "Calculatrice d'ondes", link: "/calculator/fr/wave/", description: "Calculez les propriétés des ondes.", showMain: true },
  { name: "Calculatrice de pression", link: "/calculator/fr/pressure/", description: "Calculez la pression exercée sur une surface.", showMain: true },
  { name: "Calculatrice de résistance électrique", link: "/calculator/fr/resistance-calculator/", description: "Calculez la résistance d'un conducteur.", showMain: true },
  { name: "Calculatrice de la masse de la Terre", link: "/calculator/fr/earth-mass-calculator/", description: "Calculez des paramètres liés à la masse de la Terre.", showMain: true },
  { name: "Calculatrice solaire (panneaux et batteries)", link: "/calculator/fr/solar-calculator/", description: "Calculez le nombre de panneaux solaires nécessaires.", showMain: true },
  { name: "Calculatrice de densité de l'eau", link: "/calculator/fr/water-density-calculator/", description: "Calculez la densité de l'eau à différentes températures.", showMain: true },
  { name: "Calculatrice de capacité du transformateur", link: "/calculator/fr/transformer-capacity-calculator/", description: "Calculez la capacité d'un transformateur électrique.", showMain: true },
  { name: "Calculatrice de force", link: "/calculator/fr/force-calculator/", description: "Calculez la force avec F=ma.", showMain: true },
  { name: "Calculatrice de puissance mécanique", link: "/calculator/fr/power-calculator/", description: "Calculez la puissance mécanique.", showMain: true },
  { name: "Calculatrice de travail mécanique", link: "/calculator/fr/work-calculator/", description: "Calculez le travail mécanique effectué.", showMain: true },
  { name: "Calculatrice de courant électrique", link: "/calculator/fr/current-calculator/", description: "Calculez l'intensité du courant électrique.", showMain: true },
  { name: "Calculatrice de tension électrique", link: "/calculator/fr/voltage-calculator/", description: "Calculez la tension électrique.", showMain: true },
  { name: "Calculatrice de résistances en parallèle", link: "/calculator/fr/resistor-calculator/", description: "Calculez la résistance équivalente en parallèle.", showMain: true },
  { name: "Calculatrice de résistances en série", link: "/calculator/fr/resistor-calculator/", description: "Calculez la résistance équivalente en série.", showMain: true },
];

export const chemistryCalculators_Fr = [
  {
    name: "Calculatrice de masse de fer",
    link: "/calculator/fr/iron-mass/",
    description:
      "La calculatrice de masse de fer calcule la masse d'une pièce de fer en fonction des dimensions saisies.",
    showMain: true,
  },
  {
    name: "Calculatrice de masse d'eau",
    link: "/calculator/fr/water-mass/",
    description:
      "La calculatrice de masse d'eau calcule la masse d'eau en fonction du volume et de la densité d'eau.",
    showMain: true,
  },
  {
    name: "Calculatrice de masse molaire",
    link: "/calculator/fr/molar-mass/",
    description:
      "Toutes les substances sont composées d'atomes ou de molécules. En chimie, il est crucial de mesurer avec précision leurs quantités. Pour déterminer le nombre de réactifs et de produits des réactions chimiques, nous utilisons l'unité de base SI de la mole, le symbole mol.",
    showMain: true,
  },
  { name: "Calculatrice de volume de gaz", link: "/calculator/fr/gas-volume-calculator/", description: "Calculez le volume d'un gaz.", showMain: true },
  { name: "Calculatrice d'énergie libre de Gibbs", link: "/calculator/fr/gibbs-free-energy/", description: "Calculez l'énergie libre de Gibbs d'une réaction.", showMain: true },
  { name: "Calculatrice de charge ionique", link: "/calculator/fr/ion-charge-calculator/", description: "Calculez la charge d'un ion.", showMain: true },
  { name: "Calculatrice Ksp (produit de solubilité)", link: "/calculator/fr/ksp-calculator/", description: "Calculez le produit de solubilité Ksp.", showMain: true },
  { name: "Calculatrice de masse métallique", link: "/calculator/fr/metal-weight/", description: "Calculez la masse d'un métal.", showMain: true },
  { name: "Calculatrice de titrage", link: "/calculator/fr/titration/", description: "Calculez les paramètres d'une réaction de titrage.", showMain: true },
  { name: "Calculatrice de densité", link: "/calculator/fr/density-calculator/", description: "Calculez la densité d'une substance.", showMain: true },
  { name: "Calculatrice du point de rosée", link: "/calculator/fr/dew-point-calculator/", description: "Calculez le point de rosée.", showMain: true },
  { name: "Calculatrice de dilution", link: "/calculator/fr/dilution-calculator/", description: "Calculez les dilutions de solutions chimiques.", showMain: true },
  { name: "Calculatrice de la loi des gaz parfaits", link: "/calculator/fr/ideal-gas-law-calculator/", description: "Calculez les propriétés d'un gaz parfait.", showMain: true },
  { name: "Calculatrice de molarité", link: "/calculator/fr/molarity-calculator/", description: "Calculez la molarité d'une solution.", showMain: true },
  { name: "Calculatrice de masse moléculaire", link: "/calculator/fr/molecular-weight-calculator/", description: "Calculez la masse moléculaire d'un composé.", showMain: true },
  { name: "Calculatrice de moles", link: "/calculator/fr/moles-calculator/", description: "Calculez le nombre de moles d'une substance.", showMain: true },
  { name: "Calculatrice de pH", link: "/calculator/fr/ph-calculator/", description: "Calculez le pH d'une solution acide ou basique.", showMain: true },
  { name: "Calculatrice de solubilité", link: "/calculator/fr/solubility-calculator/", description: "Calculez la solubilité d'un composé.", showMain: true },
];

export const TimeArticles_Fr = [
  {
    name: "Jours restants jusqu'à Ramadan 2027",
    link: "/articles-fr/ramadan/",
    description:
      "Quel est le premier jour du Ramadan 2027 dans les calendriers hégirien et grégorien - Quand le Ramadan commence - Décompte jusqu'au mois du Ramadan - Combien de jours restent jusqu'au début du mois béni du Ramadan.",
  },
  {
    name: "Jours restants jusqu'à l'Aïd al-Adha 2026",
    link: "/articles-fr/eid-adha/",
    description:
      "Ici, vous trouverez le décompte jusqu'à l'Aïd al-Adha, où vous pourrez découvrir combien de jours restent jusqu'à l'Aïd al-Adha.",
  },
  {
    name: "Jours restants jusqu'à l'Aïd al-Fitr 2026",
    link: "/articles-fr/eid-fatr/",
    description:
      "Ici, vous trouverez le décompte jusqu'à l'Aïd al-Fitr, où vous pourrez découvrir combien de jours restent jusqu'à l'Aïd al-Fitr.",
  },
];
export const foodCalculators_Fr = [
  { name: "Calculatrice à Pizza", link: "/calculator/fr/pizza-calculator/", description: "Calculez la quantité de pâte, sauce et fromage pour n'importe quelle taille de pizza.", showMain: true },
  { name: "Calculatrice Crème Glacée", link: "/calculator/fr/ice-cream-calculator/", description: "Calculez les ingrédients nécessaires pour faire de la crème glacée maison.", showMain: true },
  { name: "Conversion Moules à Gâteau", link: "/calculator/fr/cake-pan-conversion/", description: "Convertissez facilement les tailles de moules à gâteau entre différentes formes.", showMain: true },
  { name: "Calculatrice Crêpe Parfaite", link: "/calculator/fr/pancake-calculator/", description: "Obtenez la recette de crêpe parfaite selon le nombre de portions souhaité.", showMain: true },
  { name: "Grammes en Tasses", link: "/calculator/fr/grams-to-cups/", description: "Convertissez les grammes en tasses pour tous les ingrédients courants.", showMain: true },
  { name: "Conversion Mesures Cuisson", link: "/calculator/fr/cooking-measurement/", description: "Convertissez entre tasses, cuillères, grammes, onces et millilitres.", showMain: true },
  { name: "Calculatrice Chocolat", link: "/calculator/fr/chocolate-calculator/", description: "Calculez la quantité de chocolat nécessaire pour vos préparations.", showMain: true },
  { name: "Calculatrice Beignets", link: "/calculator/fr/donut-calculator/", description: "Calculez les ingrédients pour faire des beignets selon le nombre de portions.", showMain: true },
];